import Box from "@mui/material/Box";
import type React from "react";

import { zinc } from "./tokens";

type FeedCardVariant = "mine" | "driver" | "default";

export default function FeedCard({
  variant,
  playing,
  hasArtifact,
  children,
}: {
  variant: FeedCardVariant;
  playing: boolean;
  hasArtifact: boolean;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={(theme) => ({
        borderRadius: 1,
        border: variant === "driver" ? "2px solid" : "1px solid",
        borderColor: zinc[700],
        bgcolor: hasArtifact && variant !== "mine" ? theme.palette.brandOther[600] : zinc[800],
        p: 1,
        ...(variant === "mine" && {
          borderColor: theme.palette.altBrand[400],
          bgcolor: theme.palette.altBrand[500],
        }),
        ...(variant === "driver" && {
          borderColor: theme.palette.altBrand[400],
        }),
        ...(playing && {
          boxShadow: "0 0 0 2px #22c55e",
        }),
      })}
    >
      {children}
    </Box>
  );
}
